export default __webpack_public_path__ + "static/media/delivery.ce049e13.svg";